import { postApiGalaxyServer } from 'services';

export interface GetImpersonateTokenSuccessResponse {
  token: string;
}

export interface GetImpersonateTokenErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export interface GetImpersonateTokenPayload {
  account_id: number;
  skip_onboarding: boolean;
  realm_id: string;
  super_admin_email: string;
  tags: string[];
  /** GLX-1255: galaxy-server verifies the member's role on this team before impersonating */
  team_id: number;
}

export const getImpersonateToken = ({
  params,
  token,
  config = {},
}: BaseApiParams<GetImpersonateTokenPayload>) =>
  postApiGalaxyServer<GetImpersonateTokenPayload, GetImpersonateTokenSuccessResponse>(
    `/rails_api/impersonate`,
    params,
    config,
    token,
  );
